(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /**
   * This directive takes a string and compiles it ONCE allowing string directives
   * to be bound to the local scope of the compile-directive component.
   *
   * Example:
   * "This is an example string <video-embed ... />"
   *
   * This would compile the videoEmbed directive from the actual string.
   * This is useful if you need to dynamically build directives from a given string,
   * such as the way we build the videoEmbed directive from user input in the metric
   * card.
   *
   * NOTE: If you'd like a custom directive to be allowed, you must enabled them in the
   * $sanitizeProvider in the initial app configuration. Otherwise they will be sanitized
   * and will not display in the final output.
   */
  directive('compile', ['$compile', '$sanitize', function ($compile, $sanitize) {
    return function (scope, element, attrs) {
      var stopWatch = scope.$watch(function (scope) {
        // watch the 'compile' expression for changes
        return scope.$eval(attrs.compile);
      }, function (value) {
        if (!value) {
          return;
        }

        // This works because we've whitelisted the 'video-embed' directive and it's attributes
        // in the sanitizeProvider. If new attributes are needed, they'll need to be added in
        // the $sanitizeProvider configuration
        value = $sanitize(value);

        // when the 'compile' expression changes
        // assign it into the current DOM
        element.html(value);

        // compile the new DOM and link it to the current
        // scope.
        // NOTE: we only compile .childNodes so that
        // we don't get into infinite loop compiling ourselves
        $compile(element.contents())(scope);
        stopWatch();
      });
    };
  }]);
})();
